export const withBusinessId = (mapping) => {
    if(mapping.isBusinessIdEnabled) return true
    return !!mapping.customDataMapping.customFieldsMappings.some(f => f.type === 'businessId')
}

export const getBusinessIdFielName = (mapping) => {
    if(mapping.isBusinessIdEnabled) return 'Business Id'
    const field = mapping.customDataMapping.customFieldsMappings.find(f => f.type === 'businessId')
    return field?.fieldName ?? 'Business Id'
}